import createAppSlice from 'app/createAppSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { IPlan, IAvailableOffer, IPlanChangeEligibility } from './types';

const initialState: IPlan = {
  entitlements: {},
  availableOffers: [],
  availableOffersLoaded: false,
  planChangeEligibility: null,
};

const PlanSlice = createAppSlice({
  name: 'plan',
  initialState,
  reducers: {
    setPlanEntitlements: (
      state,
      action: PayloadAction<IPlan['entitlements']>,
    ) => {
      state.entitlements = action.payload;
    },
    setAvailableOffers: (state, action: PayloadAction<IAvailableOffer[]>) => {
      state.availableOffers = action.payload;
      state.availableOffersLoaded = true;
    },
    setPlanChangeEligibility: (
      state,
      action: PayloadAction<IPlanChangeEligibility>,
    ) => {
      state.planChangeEligibility = action.payload;
    },
    resetAvailableOffers: (state) => {
      state.availableOffers = [];
      state.availableOffersLoaded = false;
    },
  },
});

export const {
  setPlanEntitlements,
  setAvailableOffers,
  setPlanChangeEligibility,
  resetAvailableOffers,
} = PlanSlice.actions;
export default PlanSlice.reducer;
